export default "__VITE_ASSET__61694a62__"